<template>
  <div class="p-5 question-setting" @click.stop>
    <template v-if="selectQuestion">
      <control-setting-component :question="selectQuestion" @update="onUpdate" />
    </template>
    <template v-else>
      <div class="text-center text-theme-black-450" style="padding-top: 200px">
        <span style="font-size: 40px">
          <i class="icon-bianji1"></i>
        </span>
        <div class="leading-22 mt-4 text-medium">
          <span>没有选定的题目</span>
          <br />
          <span>请添加或者选择一个题目</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ControlSettingComponent } from '@/question/control/setting'

export default {
  name: 'ControlSetting',
  computed: {
    ...mapGetters(['selectQuestion'])
  },
  components: { ControlSettingComponent },
  created() {
    this.updateHandler = this.updateFactory()
  },
  beforeDestroy() {
    this.updateHandler = null
  },
  watch: {
    selectQuestion() {
      this.updateHandler = this.updateFactory()
    }
  },
  methods: {
    updateFactory() {
      let question = this.selectQuestion
      const vm = this
      return function () {
        if (!question) return
        vm.$emit('update', question)
      }
    },
    onUpdate() {
      this.updateHandler()
    }
  }
}
</script>
